import type { UrlObject } from 'url';

import { buildWebsiteUrl } from '@repo/utils/url';

import { buildTemplatesUrl } from 'global/utils/templateParams';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { ReactComponentType } from '../types';

import TemplateFeed from './TemplateFeed';

export const collectTemplateFeedParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof TemplateFeed> | undefined => {
  if (!('templateFeed' in page) || !page.templateFeed) {
    return undefined;
  }

  const templates = page.templateFeed.templates
    ?.filter((x) => !!x)
    .map((x) => x.templateId);

  if (!templates || templates.length === 0) {
    return undefined;
  }

  let moreButtonLink = '/designs/all';

  const isUseCasePage = 'use_case' in page;
  if (isUseCasePage) {
    const useCaseSlug = page.use_case.slug;
    const templateUrl = buildTemplatesUrl(undefined, undefined, useCaseSlug);
    moreButtonLink = buildWebsiteUrl((templateUrl as UrlObject).pathname ?? '');
  }

  const isSubUseCasePage = 'sub_use_case' in page;
  if (isSubUseCasePage) {
    const useCaseSlug = page.sub_use_case.use_case.slug;
    const subUseCaseSlug = page.sub_use_case.slug;

    const templateUrl = buildTemplatesUrl(
      undefined,
      undefined,
      useCaseSlug,
      subUseCaseSlug
    );

    moreButtonLink = buildWebsiteUrl((templateUrl as UrlObject).pathname ?? '');
  }

  return {
    component: ReactComponentType.TemplateFeed,
    props: {
      title: page.templateFeed.title,
      description: page.templateFeed.description,
      templates: templates,
      moreButtonLink: moreButtonLink,
    },
  };
};
